// extracted by mini-css-extract-plugin
module.exports = {"text":"Export_text__3XaNg","footer":"Export_footer__24LRc"};